import useConfirmDeleteSus from '@/components/Sus/buttons/useConfirmDeleteSus';
import { Button } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type Props = {
  selectedIds: number[];
  /** Appelé après une suppression réussie (ex. pour vider la sélection). */
  onDeleted: () => void;
};

const SusDeleteSelectedButton = ({ selectedIds, onDeleted }: Props) => {
  const { t } = useTranslate();
  const confirmDelete = useConfirmDeleteSus();

  return (
    <Button
      variant="light"
      color="red"
      leftSection={<IconTrash size={16} stroke={1.5} />}
      onClick={() => confirmDelete(selectedIds, onDeleted)}
    >
      {t('admin.sus.delete.button', { count: selectedIds.length })}
    </Button>
  );
};

export default SusDeleteSelectedButton;
